import { AxiosError } from 'axios';
import { ProblemResponseData } from '../../infrastracture/DTOs/responses/GenericWebApiResponse';

export const getOnboardingServerErrorMessage = (error: unknown) => {
  const err = error as AxiosError<any>;

  if (err.response?.data?.status === 404) return "Wow, you're lost";
  if (err.response?.data?.message) return err.response.data.message;

  return 'Greska!';
};

export const getServerErrorMessage = (error: any) => {
  if (error === null || error === undefined) return;

  if (error?.problemResponseData) {
    return buildErrorMessageFromProblemResponseData(error.problemResponseData);
  }

  if (error?.response?.data?.problemResponseData !== undefined) {
    const { problemResponseData } = error.response.data;
    return buildErrorMessageFromProblemResponseData(problemResponseData);
  }

  if (error?.request?.status === 500) {
    return error;
  }
  if (error?.request?.status === 404) {
    return "Wow, you're lost";
  }
  return 'Greska!';
};

export const getSettlementServerErrorMessage = (error: any) => {
  if (error === null || error === undefined) return;

  if (error.problemResponseData !== undefined) {
    const { problemResponseData } = error;
    return buildErrorMessageFromProblemResponseData(problemResponseData);
  }

  if (error?.request?.status === 500) {
    return error;
  }
  if (error?.request?.status === 404) {
    return "Wow, you're lost";
  }
  return 'Greska!';
};

export const getServerGeneratedErrorMessage = (error: any) => {
  if (error === null || error === undefined) return;

  if (error?.problemResponseData?.problems) {
    return buildErrorMessageFromProblemResponseData(error.problemResponseData);
  }

  if (error?.request?.status === 500) {
    return error;
  }
  if (error?.request?.status === 404) {
    return "Wow, you're lost";
  }
  return 'Greska!';
};

export const buildErrorMessageFromProblemResponseData = (error: ProblemResponseData) => {
  const message = error.problems.map((problem) => problem.details || problem.message).join(', ');
  return message;
};

export function maybeThrowError(chanceToThrowError: number = 10): void {
  const a = Math.floor(Math.random() * 100);
  if (a < chanceToThrowError) throw Error('noo0000000...🙀');
}
